<table class="table table-bordered" style="width: 90%; border-collapse: collapse; margin-left: 30px;">
  <thead>
    <tr style="background: #ddd; font-weight: bold; text-align: center;">
      <th class="br-bottom br-right br-top">#</th>
      <th class="br-bottom br-right br-top">Seller Name</th>
      <th class="br-bottom br-right br-top">Booking Date</th>
      <th class="br-bottom br-right br-top">Representative</th>
      <th class="br-bottom br-right br-top">Copies</th>
      <th class="br-bottom br-right br-top">Issue Amount</th>
      <th class="br-bottom br-right br-top">Net Amount</th>
      <th class="br-bottom br-right br-top">Before GST</th>
      <th class="br-bottom br-right br-top">GST</th>
      <th class="br-bottom br-right br-top">Total Amount</th>
      <th class="br-bottom br-right br-top">Jama Baki</th>
      <th class="br-bottom br-right br-top">Yene Baki</th>
    </tr>
  </thead>

  <tbody>
    <!-- Loop over each booking_date group -->
    <ng-container *ngFor="let item1 of inDetailsRegReportdatewise; let i = index">
      <!-- Booking Date Header Row -->
      <tr style="background: #f2f2f2; font-weight: bold;">
        <td colspan="12" class="br-bottom br-top br-right" style="text-align: left;">
          Booking Date : {{ item1.booking_date }}
        </td>
      </tr>

      <!-- Loop over issue_data for that booking_date -->
      <ng-container *ngFor="let item of item1.issue_data; let j = index">
        <tr>
          <td class="br-bottom br-right br-top" style="font-weight: bold; text-align: end;">
            {{ j + 1 }}
          </td>
          <td class="br-bottom br-right br-top" style="text-align: end; font-weight:600;">
            {{ item.issue_seller_name }}
          </td>
          <td class="br-bottom br-right br-top" style="text-align: end; font-weight: 500;">
            {{ item1.booking_date }}
          </td>
          <td class="br-bottom br-right br-top" style="text-align: end; font-weight: 600;">
            {{ item.rep_name }}
          </td>
          <td class="br-bottom br-right br-top" style="text-align: end; font-weight: 500;">
            {{ item.issue_copies }}
          </td>
          <td class="br-bottom br-right br-top" style="text-align: end; font-weight: 500;">
            {{ item.issue_amt }}
          </td>
          <td class="br-bottom br-right br-top" style="text-align: end; font-weight: 500;">
            {{ item.net_amount }}
          </td>
          <td class="br-bottom br-right br-top" style="text-align: end; font-weight: 500;">
            {{ item.beforegst_amt }}
          </td>
          <td class="br-bottom br-right br-top" style="text-align: end; font-weight: 500;">
            {{ item.gst }}
          </td>
          <td class="br-bottom br-right br-top" style="text-align: end; font-weight: 500;">
            {{ item.total_amount }}
          </td>
          <td class="br-bottom br-right br-top" style="text-align: end; font-weight: 500;">
            {{ item.pymt_rcv_amt ||0}}
          </td>
          <td class="br-bottom br-right br-top" style="text-align: end; font-weight: 500;">
            {{ item.remaining_amt }}
          </td>
        </tr>
      </ng-container>

      <!-- Subtotal Row for this booking_date -->
      <tr style="background: white; font-weight: bold;">
        <td colspan="4" class="br-bottom br-right br-top" style="text-align: right;">
          Subtotal ({{ item1.booking_date }})
        </td>
        <td class="br-bottom br-right br-top" style="text-align: end;">
          {{ item1.issue_copies }}
        </td>
        <td class="br-bottom br-right br-top" style="text-align: end;">
          {{ item1.total_advt_amount }}
        </td>
        <td class="br-bottom br-right br-top" style="text-align: end;">
          {{ item1.total_discounted_amt }}
        </td>
        <td class="br-bottom br-right br-top" style="text-align: end;">
          {{ item1.total_before_gst }}
        </td>
        <td class="br-bottom br-right br-top" style="text-align: end;">
          {{ item1.total_gst }}
        </td>
        <td class="br-bottom br-right br-top" style="text-align: end;">
          {{ item1.total_amt }}
        </td>
        <td class="br-bottom br-right br-top" style="text-align: end;">
          {{ item1.total_rcv }}
        </td>
        <td class="br-bottom br-right br-top" style="text-align: end;">
          {{ item1.total_pending }}
        </td>
      </tr>
    </ng-container>
  </tbody>

  <!-- Grand Total Footer -->
<tfoot>
  <tr style="background: lightyellow; font-weight: bold;">
    <td colspan="4" class="br-bottom br-right br-top" style="text-align: right;">
      Grand Total
    </td>
    <td class="br-bottom br-right br-top" style="text-align: end;">{{ issuecopies }}</td>
    <td class="br-bottom br-right br-top" style="text-align: end;">{{ totaladvtamt }}</td>
    <td class="br-bottom br-right br-top" style="text-align: end;">{{ netadvtamt }}</td>
    <td class="br-bottom br-right br-top" style="text-align: end;">{{ totalbeforegst_amt }}</td>
    <td class="br-bottom br-right br-top" style="text-align: end;">{{ totalgst }}</td>
    <td class="br-bottom br-right br-top" style="text-align: end;">{{ totaladvtamt + totalgst }}</td>
    <td class="br-bottom br-right br-top" style="text-align: end;">{{ jamatotal }}</td>
    <td class="br-bottom br-right br-top" style="text-align: end;">{{ total_pending }}</td>
  </tr>
</tfoot>

</table>